import { MESSAGE_STATUSES } from "../../constants";

export const isMessageSend = (status: MESSAGE_STATUSES): boolean =>
  status === MESSAGE_STATUSES.SEND;

export const isMessageReceived = (status: MESSAGE_STATUSES): boolean =>
  status === MESSAGE_STATUSES.RECEIVED;

export const isMessageRead = (status: MESSAGE_STATUSES): boolean =>
  status === MESSAGE_STATUSES.READ;

export const isMessageError = (status: MESSAGE_STATUSES): boolean =>
  status === MESSAGE_STATUSES.ERROR;
